import { render, staticRenderFns } from "./UnsavedChangesModal.vue?vue&type=template&id=d32dccaa&scoped=true&"
import script from "./UnsavedChangesModal.vue?vue&type=script&lang=js&"
export * from "./UnsavedChangesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d32dccaa",
  null
  
)

export default component.exports